<template>
  <div :style="styles.base" @click="handleClickEvent">
    <c-button ref="button" :style="computedStyle" v-bind="$props"/>
    <c-base-dialog v-model="isShowPop" :option="popOption" @close="isShowPop=false" v-transfer-dom>
      <template slot="body">
        <div :class="getCss('task-finish-tips')">
          <div>{{ taskFinishMsg }}</div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

const clickFinishTaskType = 1; // 进页面任务点击触发（点击直接判定是否符合完成任务） 如果关联组件要等待完成组件回调
const autoFinishTaskType = 2; // 进页面任务自动触发  自动触发动作 和 自动触发完成任务请求 (自动触发动作和流程)
const halfClickHalfFinishFinishTaskType = 3;  // 进页面任务可点击 自动触发动作   并且会自动请求完流程(不自动触发动作 如果关联了)
const getRewardDirectFinishTaskType = 4;  // 直接领取奖励在执行任务
const jumpPageReturnBackFinishTaskType = 5; //  进页面点击任务后到需回页面触发任务

export default {
  name: 'CButtonTask',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'button-Task-',
      status: 'Task',
      isShowPop: false,
      taskIdRemarkKey: '',
      finishTaskCallBackNum: 0,
    };
  },
  computed: {
    backgroundImageMap() {
      return {
        Task: this.configurationData.TaskImg,
        Tasked: this.configurationData.TaskedImg,
      };
    },
    popOption() {
      return Object.assign({}, this.dialogConfig, {
        header: '温馨提示',
        fotter: false,
      });
    },
    computedStyle() {
      // const {isStretching} = this.configurationData;
      return {
        backgroundImage: `url(${this.backgroundImageMap[this.status]})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        left: 0,
        top: 0,
        display: 'block',
      };
    },
    enable() {
      const packageStatus = this.quaInfo[this.configurationData.queryTaskStatusFlowID];
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    taskFinishMsg() {
      return this.configurationData.taskFinishMsg || '';
    },
    // 自动完成类任务
    isAutoFinishTaskType() {
      const { taskFinishType } = this.configurationData;
      return taskFinishType === autoFinishTaskType;
    },
    // 点击类任务
    isHalfClickHalfFinishFinishTaskType() {
      const { taskFinishType } = this.configurationData;
      return taskFinishType === halfClickHalfFinishFinishTaskType;
    },
    // 点击类任务
    isClickFinishTaskType() {
      const { taskFinishType } = this.configurationData;
      return taskFinishType === clickFinishTaskType || taskFinishType === halfClickHalfFinishFinishTaskType;
    },
    //  直接领取后在触发任务
    isGetRewardDirectFinishTaskType() {
      return this.configurationData.taskFinishType === getRewardDirectFinishTaskType;
    },
    //  跳转回页面在领取
    isJumpPageReturnBackFinishTaskType() {
      return this.configurationData.taskFinishType === jumpPageReturnBackFinishTaskType;
    },
    // 是否有关联组件
    needHasCallComponent() {
      const { targetComponentId = '', isRelationComponent = false } = this.configurationData;
      return targetComponentId && isRelationComponent;
    },
    isIos() {
      return this.$platform.isIos;
    },
    initializeTaskStatusFromQua() {
      const { queryTaskStatusType = 1 } = this.configurationData;
      return parseInt(queryTaskStatusType, 10) === 1;
    },
  },
  mounted() {
    console.log('version = 1.0.0 task button configurationData=', this.configurationData);
    this.initialize();
  },
  methods: {
    setButtonClick() {
      this.$refs.button.setClickHandler(this.handleTask, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: this.configurationData.forceRole,
      });
    },
    async processAutoTask() {
      const time = Math.floor(Math.random() * 2000) + 200;
      await this.doSleep(time);
      console.log(' processAutoTask time sleep = ', time);
      const { forceRole } = this.configurationData;
      if (this.finishTaskCallBackNum >= 1) {
        console.error(
          ' exist endless loop  risk and  stop   continue execute  finishTaskCallBackNum  = ',
          this.finishTaskCallBackNum, 'task configurationData = ', this.configurationData,
        );
        return false;
      }
      //  自动触发任务且不需要角色
      if (this.isAutoFinishTaskType && !forceRole) {
        // 主动触发 完成动作和任务
        this.doTask();
        this.finishTask();
        return true;
      }
      if (this.isHalfClickHalfFinishFinishTaskType && !forceRole) {
        // 主动触发 完成任务 不触发动作
        this.finishTask();
        return true;
      }

      if (this.isJumpPageReturnBackFinishTaskType && !forceRole) {
        this.checkFinishTaskInSession();
      }
    },
    checkTaskStatus() {
      if (this.enable) {
        this.status = 'Task';
        this.processAutoTask();
      } else {
        this.status = 'Tasked';
      }
      console.log('on checkStatus this.status=', this.status);
    },
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    async checkTaskFromApi() {
      try {
        const { queryTaskStatusFlowID } = this.configurationData;
        if (!queryTaskStatusFlowID) return false;
        const time = Math.floor(Math.random() * (370 - 30)) + 200;
        await this.doSleep(time);
        const response = await this.flowRequest({
          flowId: queryTaskStatusFlowID,
          params: {
            role: this.roleInfo,
          },
        });
        console.log('checkTaskFromApi queryTaskStatusFlowID=', queryTaskStatusFlowID);
        console.log('checkTaskFromApi response=', response);
        const { ret = 0, data = {} } = response || {};
        const { ret: resRet } = data;
        if (ret !== 0 || resRet !== 0) {
          // 业务返回错误代码 即为不满足任务
          this.status = 'Tasked';
          console.log('checkTaskFromApi response= not Tasked', response);
        } else {
          // 正常返回  即为满足任务条件
          this.status = 'Task';
          //  自动触发任务且不需要角色
          this.processAutoTask();
          console.log('checkTaskFromApi response Task', response);
        }
      } catch (e) {
        console.error('checkTaskFromApi  check fail, err=', e);
      }
    },

    initialize() {
      if (this.$isInEditor) return;
      // 设置点击事件
      this.setButtonClick();
      const { startTime = '', noneStartMsg = '' } = this.configurationData;
      if (startTime && noneStartMsg && this.getTimeStamp() < this.getTimeStamp(startTime)) {
        console.error('task do not start  and  startTime = ', startTime, 'noneStartMsg = ', noneStartMsg);
        return false;
      }
      const { forceRole } = this.configurationData;
      // 全自任务不用点击
      const self = this;
      //  如果不自动执行
      if (!forceRole) {
        // 检测是否完成
        if (this.initializeTaskStatusFromQua) {
          this.$onQuaRefreshed(this.checkTaskStatus);
        } else {
          this.$onQuaRefreshed(this.checkTaskFromApi);
        }
        return false;
      }
      // 自动执行需要角色
      if (forceRole) {
        const randomKey = this.getRandomId();

        const autoHandleTask = () => {
          let temp = {};
          Object.defineProperty(window, randomKey, {
            get() {
              return temp;
            },
            set: (newValue) => {
              console.log('set = ', newValue);
              temp = newValue;
              if (newValue && Object.keys(newValue).length >= 2) {
                if (self.status === 'Task') {
                  !self.isJumpPageReturnBackFinishTaskType ? self.finishTask() : self.checkFinishTaskInSession();
                }
              }
            },
            enumerable: true,
            configurable: true,
          });
        };
        const setLockForceRoleFunc = (key) => {
          console.log('window[randomKey]', window[randomKey], randomKey);
          if (Object.keys(window[randomKey]).length >= 2) return;
          window[randomKey] = {
            ...window[randomKey],
            [key]: 1,
          };
          console.log('window[randomKey]', window[randomKey], randomKey);
        };
        // 需要角色信息且需要
        autoHandleTask();
        if (self.isAutoFinishTaskType || self.isHalfClickHalfFinishFinishTaskType) {
          this.$onRoleReady(async () => {
            setLockForceRoleFunc('onTaskRoleReady');
          });
        }

        this.$onQuaRefreshed(async () => {
          if (this.initializeTaskStatusFromQua) {
            this.checkTaskStatus();
          } else {
            await this.checkTaskFromApi();
          }
          if (this.status === 'Task') {
            setLockForceRoleFunc('onTaskQuaRefreshed');
          }
        });
      }
    },
    getRandomId(targetComponentId) {
      // eslint-disable-next-line no-param-reassign
      targetComponentId = targetComponentId || `${Math.random().toString(36)
        .slice(-10)}_${Math.floor(Math.random() * 10000000)}`;
      return `__task_id_${targetComponentId}`;
    },
    getTimeStamp(time) {
      if (time) {
        // ios 的时间格式需要更改一下
        // eslint-disable-next-line no-param-reassign
        time = time.replace(/-/g, '/');
        return parseInt(new Date(time).getTime() / 1000, 10);
      }
      return parseInt(new Date().getTime() / 1000, 10);
    },
    async handleTask() {
      // 已灰  不能再点击
      if (this.status === 'Tasked') {
        return;
      }
      const { startTime = '', noneStartMsg = '' } = this.configurationData;
      if (startTime && noneStartMsg && this.getTimeStamp() < this.getTimeStamp(startTime)) {
        return this.$alert({ msg: noneStartMsg || '暂未开放' });
      }
      if (this.isGetRewardDirectFinishTaskType) {
        //  是否忽略完成任务错误
        const { isIgnoreTaskError = false } = this.configurationData;
        const handleRes =  await this.finishTask('click') || {};
        if (isIgnoreTaskError === false  && handleRes === true) {
          this.needHasCallComponent && this.doTask();
        }
        if (isIgnoreTaskError === true) {
          this.needHasCallComponent && this.doTask();
        }
      } else {
        this.needHasCallComponent ? this.doTask() : this.finishTask('click');
      }
    },
    reportFunc({ status }) {
      const { reportEventKey = 'none', reportOpenUrl = '' } = this.configurationData;
      if (!reportEventKey || reportEventKey === 'none') {
        return false;
      }
      // 签到sign_in
      // 签到download
      const mapping = {
        // 签到
        sign_in: {
          eventKey: 'sign_in',
          eventData: {
            status,
            sign_in_times: 0,
          },
        },
        // 加入微信群聊
        enter_group_wx: {
          eventKey: 'enter_group',
          eventData: {
            type: 'wx',
          },
        },
        // 加入QQ群聊
        enter_group_qq: {
          eventKey: 'enter_group',
          eventData: {
            type: 'qq',
          },
        },
        // 加入微信公众号
        follow_group_wx: {
          eventKey: 'follow_group',
          eventData: {
            type: 'wx',
          },
        },
        // 跳转
        open_url: {
          eventKey: 'open_url',
          eventData: {
            url: reportOpenUrl,
          },
        },
        enter_gonghui: {
          eventKey: 'enter_gonghui',
          eventData: {},
        },
        pay: {
          eventKey: 'pay',
          eventData: {
            status: '1',
          },
        },

      };
      const { eventKey, eventData } = mapping[reportEventKey] ? mapping[reportEventKey] : {};
      if (!eventKey || !eventData) {
        console.error('task button report config eventKey and eventData not mapping');
        return false;
      }
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey,
          eventData,
        };
        this.reportClickRaw(params);
        console.log('reportFunc download data =', params);
      }
    },
    // 触发任务
    async doTask() {
      // 已灰  不能再点击
      if (this.status === 'Tasked') {
        return;
      }
      const { targetComponentId = '', isRelationComponent = false, taskFinishType = 1 } = this.configurationData;
      if (!this.needHasCallComponent) {
        console.error('targetComponentId not need  = ', targetComponentId, isRelationComponent);
        return;
      }
      if (!this.taskIdRemarkKey) {
        this.taskIdRemarkKey = this.getRandomId(targetComponentId);
        const that = this;
        Object.defineProperty(window, this.taskIdRemarkKey, {
          set: (newValue) => {
            if (newValue > 0) {
              console.log('任务完成~~~~~~~~~~~~~~~~~~~~~~~');
              that.finishTask('click');
            }
          },
          enumerable: true,
          configurable: true,
        });
      }
      const parentRef = (node) => {
        if (!node?.$parent) {
          return {};
        }
        // eslint-disable-next-line  no-underscore-dangle
        if (node.$parent && node.$parent?.$el?._prevClass === 'page-content') {
          return node.$parent;
        }
        return parentRef(node.$parent);
      };
      const parentNode = parentRef(this.$refs.button);
      if (!parentNode) {
        console.error('--parentNode-- not found ', parentNode);
      }
      const component = parentNode?.$refs[targetComponentId]?.[0];

      if (component && typeof component.doTaskAction === 'function') {
        if (taskFinishType === jumpPageReturnBackFinishTaskType) {
          this.listenSessionInIosLoadPage();
        }
        console.info('--target component--  found doTaskAction function  component.doTaskAction');
        component.doTaskAction(this.taskIdRemarkKey, taskFinishType === jumpPageReturnBackFinishTaskType);
        return false;
      }
      // 调用c-button的事件
      if (component && typeof component.handleClick === 'function') {
        console.info('--target component--  found doTaskAction function  component.handleClick');
        component.handleClick(this.taskIdRemarkKey, taskFinishType === jumpPageReturnBackFinishTaskType);
        return false;
      }
      console.error('--target component-- not found  or not found doTaskAction or handleClick function ', component);
    },
    // 完成任务
    // 用户点击主动触发的 要弹出错误信息
    // 主动触发的任务 不要弹出错误信息
    async finishTask(via) {
      console.log('任务完成~~~~~~~~~~~~~~~~~~~~~~~ 请求 中');
      // blockUserTriggerErrorMsg 屏蔽用户主动触发的错误提示
      const { flowID = 0, blockUserTriggerErrorMsg = false } = this.configurationData;
      if (flowID > 0) {
        console.log('run  game book callback and callBackFlowId = ', flowID);
        const response = await this.flowRequest({
          flowId: flowID,
          params: {
            role: this.roleInfo,
          },
        });
        console.log('任务完成~~~~~~~~~~~~~~~~~~~~~~~ response = ', response);
        const { ret = 0, msg: requestMsg } = response;
        const { ret: resRet = -1, msg } = response.data || {};
        if (ret !== 0 || resRet !== 0) {
          via === 'click' && blockUserTriggerErrorMsg === false && this.$alert({ msg: requestMsg || msg || '任务操作失败' });
          this.reportFunc({ status: '0' });
          return false;
        }
        // 如果配置错误的话  或 需要完成数量数量大于1 这里会有死循环的风险
        this.finishTaskCallBackNum += 1;
        this.refreshQua(); // 刷新礼包
        // 任务完成
        if (this.taskFinishMsg) {
          this.isShowPop = true;
        }
        console.log('任务完成~~~~~~~~~~~~~~~~~~~~~~~');
        this.reportFunc({ status: '1' });
        return true;
      }
      return false;
    },
    checkFinishTaskInSession() {
      console.log('checkFinishTaskInSession----------------');

      const { targetComponentId = '', isRelationComponent = false } = this.configurationData;
      if (!targetComponentId || !isRelationComponent) {
        return false;
      }
      const id = this.getRandomId(targetComponentId);
      const res = window.sessionStorage.getItem(id);
      console.log('checkFinishTaskInSession res = ', res);
      if (!res) return false;
      if (parseInt(res, 10) === 1) {
        window.sessionStorage.removeItem(id);
        this.finishTask();
        return true;
      }
      return false;
    },
    listenSessionInIosLoadPage() {
      const { targetComponentId = '', isRelationComponent = false } = this.configurationData;
      if (!targetComponentId || !isRelationComponent) {
        return false;
      }
      const sessionKey = this.getRandomId(targetComponentId);
      const self = this;
      const timeId = setInterval(() => {
        const res = window.sessionStorage.getItem(sessionKey);
        console.log('listen sessionStorage res =', res);
        if (res && parseInt(res, 10) === 1) {
          clearInterval(timeId);
          window.sessionStorage.removeItem(sessionKey);
          self.finishTask();
          console.log('delete sessionStorage res =', res);
        }
      }, 500);
      setTimeout(() => {
        if (timeId) {
          clearInterval(timeId);
          console.log('timeout clearInterval sessionStorage timeId =', timeId);
        }
      }, 10000);
    },


  },
}
;
</script>
<style lang="scss">
@import './styles.scss';
</style>
